module.exports = __webpack_public_path__ + "static/media/chuck.3867364c.jpg";